var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCancelBlank = function SvgCancelBlank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_616_24592)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.06589 7.99993L4.19922 5.19993L5.13255 4.2666L7.93255 7.0666L10.7326 4.2666L11.6659 5.19993L8.93255 7.99993L11.7326 10.7999L10.7992 11.7333L7.99922 8.93327L5.19922 11.7333L4.26589 10.7999L7.06589 7.99993Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.1573 13.1787C10.3004 16.0404 5.71604 16.0404 2.79268 13.1787C-0.130684 10.3169 -0.0642438 5.72471 2.79268 2.79637C5.6496 -0.13197 10.234 -0.0654173 13.1573 2.79637C16.0807 5.65815 16.0142 10.3169 13.1573 13.1787ZM3.72284 3.72811C1.39744 6.05747 1.39744 9.851 3.72284 12.1804C6.04824 14.5097 9.83532 14.5097 12.1607 12.1804C14.4861 9.851 14.4861 6.05747 12.1607 3.72811C9.83532 1.39875 6.11468 1.39875 3.72284 3.72811Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_616_24592"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
export default SvgCancelBlank;